interface DeviceTypes {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

export const getDevice = (args: DeviceTypes) => {
  const { isMobile, isTablet } = args

  if (isMobile) {
    return 'Mobile Web'
  }
  if (isTablet) {
    return 'Tablet'
  }
  return 'Desktop'
}
